import { render, staticRenderFns } from "./SubcontractorList.vue?vue&type=template&id=23fcccc8"
import script from "./SubcontractorList.vue?vue&type=script&lang=js"
export * from "./SubcontractorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports